import * as React from "react";
import { cn } from "./cn";

type ContainerWidth = "default" | "narrow" | "wide" | "full";

const widths: Record<ContainerWidth, string> = {
  narrow: "max-w-3xl",
  default: "max-w-6xl",
  wide: "max-w-7xl",
  full: "max-w-none",
};

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Constrains the inner content width. @default "default" */
  width?: ContainerWidth;
  /** Render as a different element (e.g. "section", "header"). @default "div" */
  as?: React.ElementType;
}

/**
 * Horizontal page gutter + max-width wrapper. Every page region should sit in
 * a Container so left/right rhythm stays consistent across the site.
 */
export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, width = "default", as, ...props }, ref) => {
    const Comp = (as ?? "div") as React.ElementType;
    return (
      <Comp
        ref={ref}
        className={cn("mx-auto w-full px-4 sm:px-6 lg:px-8", widths[width], className)}
        {...props}
      />
    );
  },
);
Container.displayName = "Container";
